import React, { useContext, useEffect } from 'react';
import { Button, Form, Spinner, Table } from 'react-bootstrap';
import { MdFileCopy, MdEditSquare, MdDelete } from 'react-icons/md'
import { useNavigate } from 'react-router-dom';
import Zoom from 'react-medium-image-zoom';

import { get_sticker_store_data } from '../../../Controller/actions';
import { NewContext } from '../../../Context/NewContext';
import PaginationCmp from '../../../Components/Pagination/PaginationCmp';
import { Header } from '../../../Components/Header';
import { THead } from '../../../Components/Table';

import './stickerstore.css';
import PopOver from '../../../Components/Popover/PopOver';

export const StickerStore = ({ title }) => {
  const navigate = useNavigate();
  const { filterDropdown, currentTableData, setCurrentTableData, currentPage, setCurrentPage, totalPage, setTotalPage, perPage, setPerPage, isLoading, setIsLoading, confirmationModalShow, setConfirmationModalShow, deleteUpdateTag, setDeleteUpdateItem, search, setDeleteUpdateYes, checkedValues, handleCopyData, handleFilterChange, handleCheckboxChange, handleSelectAll } = useContext(NewContext);
  const simpleFields = ["Id", "Name", "Preview", "Country", "Region", "Count"];
  const dropdownFields = ["Premium", "Lock", "Latest", "Active"];
  const totalFields = simpleFields.length + dropdownFields.length + 2;

  let handleSwitch = (e) => {
    setDeleteUpdateYes("updatestickerstore");
    setDeleteUpdateItem({ id: e.target.id, [e.target.name]: !e.target.checked ? false : true });
    setConfirmationModalShow(!confirmationModalShow)
  };

  const getStickersStoreData = async (_currentPage = 1) => {
    setIsLoading(true);
    try {
      const getStickersStore = await get_sticker_store_data(_currentPage, perPage, search, filterDropdown);
      if (getStickersStore) {
        const { status, data, currentPage, perPage, totalPage } = getStickersStore;
        if (status) {
          // console.log(data);
          setCurrentTableData(data);
          setCurrentPage(currentPage);
          setPerPage(perPage);
          setTotalPage(totalPage);
        } else {
          // toast.error(message);
          setCurrentTableData([]);
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getStickersStoreData(currentPage);
  }, [deleteUpdateTag, search, filterDropdown]);

  useEffect(() => {
    document.title = `Emoji Keyboard | ${title}`
  }, [])

  return (
    <div className='table-header-main ms-auto p-3'>
      <Header title={`Sticker Store`} previewLink={`/preview`} addLink={`/stickerstoreform`} deleteUpdateTag={"alldeletestickerstores"} />
      <Table striped bordered hover responsive className='mb-3'>
        <THead
          simpleFields={simpleFields}
          dropdownFields={dropdownFields}
        />
        <tbody>
          {
            isLoading ?
              <tr>
                <td colSpan={totalFields} className='py-5'>
                  <div className="d-flex justify-content-center align-items-center">
                    <Spinner animation="border" />
                  </div>
                </td>
              </tr>
              : currentTableData.length === 0 ?
                <tr>
                  <td colSpan={totalFields} className='py-5 bg-light'>
                    <div className="d-flex justify-content-center align-items-center">
                      No Data Found
                    </div>
                  </td>
                </tr>
                : currentTableData.map((_ele, i) => (
                  <tr key={i} className="align-middle">
                    <td>
                      <Form.Check
                        type={'checkbox'}
                        id={`stickerstore-${_ele._id}`}
                        value={`${_ele._id}`}
                        checked={checkedValues.includes(`${_ele._id}`)}
                        onChange={() => handleCheckboxChange(`${_ele._id}`)}
                      />
                    </td>
                    <td>{perPage * (currentPage - 1) + (i + 1)}</td>
                    <td>{_ele.name}</td>
                    {
                      [_ele.preview].map((_is_ele, i) => (
                        <td key={i}>
                          <div className='imgTd position-relative'>
                            <img className='table-preview_img position-absolute d-block' src={`${_is_ele ? `${_is_ele}` : `../../../assets/images/no-image.png`}`} alt={_ele.name} />
                            <Zoom>
                              <img className='table-preview_img d-block' src={`${_is_ele ? `${_is_ele}` : `../../../assets/images/no-image.png`}`} alt={_ele.name} />
                            </Zoom>
                          </div>
                        </td>
                      ))
                    }
                    <td className={`text-truncate pe-4 position-relative`} style={{ maxWidth: "100px" }}>
                      {
                        _ele.country && _ele.country?.length !== 0 ?
                          <>
                            {_ele.country?.map((_theme_ele, key) => key === _ele.country?.length - 1 ? _theme_ele : `${_theme_ele}, `)}
                            <PopOver placement={"right"} data={_ele.country} />
                          </> : <span className='text-muted'>None</span>
                      }
                    </td>
                    <td className={`text-truncate pe-4 position-relative`} style={{ maxWidth: "100px" }}>
                      {
                        _ele.region && _ele.region?.length !== 0 ?
                          <>
                            {_ele.region?.map((_theme_ele, key) => key === _ele.region?.length - 1 ? _theme_ele : `${_theme_ele}, `)}
                            <PopOver placement={"right"} data={_ele.region} />
                          </> : <span className='text-muted'>None</span>
                      }
                    </td>
                    <td>{_ele.count ? _ele.count : 0}</td>
                    {
                      ["isPremium", "isLock", "isLatest", "isActive"].map((_is_ele, i) => (
                        <td key={i}>
                          {/* <Badge bg={_is_ele ? "success" : "danger"} className="fw-normal">
                            {_is_ele ? `On` : `Off`}
                          </Badge> */}
                          <Form.Check type="switch" id={_ele._id} name={_is_ele} onChange={handleSwitch} checked={_ele[_is_ele]} role="button" />
                        </td>
                      ))
                    }
                    <td>
                      <div className='d-flex action-btns'>
                        {/* <TooltipCmp placement={`top`} tooltipText={copyText}> */}
                        <Button className='p-2 me-2' variant="info" onClick={() => handleCopyData(_ele)}>
                          <MdFileCopy color='black' size={"18px"} />
                        </Button>
                        {/* </TooltipCmp> */}

                        {/* <TooltipCmp placement={`top`} tooltipText={`Edit`}> */}
                        <Button className='p-2 me-2' variant="warning" onClick={() => navigate(`/stickerstoreform`, { state: _ele })}>
                          <MdEditSquare color='black' size={"18px"} />
                        </Button>
                        {/* </TooltipCmp> */}

                        {/* <TooltipCmp placement={`top`} tooltipText={`Delete`}> */}
                        <Button className='p-2 me-2' variant="danger" onClick={() => { setDeleteUpdateYes("deletestickersStore"); setDeleteUpdateItem({ id: _ele._id, name: _ele.name }); setConfirmationModalShow(!confirmationModalShow) }}>
                          <MdDelete color='black' size={"18px"} />
                        </Button>
                        {/* </TooltipCmp> */}
                      </div>
                    </td>
                  </tr>
                ))
          }
        </tbody>
      </Table>
      <div className={`table-pagination d-flex justify-content-end ${currentTableData.length > 0 ? 'd-block' : 'd-none'}`}>
        <PaginationCmp
          currentPage={currentPage}
          totalPage={totalPage}
          getData={getStickersStoreData}
        />
      </div>
    </div>
  )
};

StickerStore.defaultProps = {
  title: "Sticker Store"
};

export default StickerStore;